document.addEventListener("DOMContentLoaded", (event) => {
  // PDP
  const swatches = document.querySelectorAll('.product__content .radio__buttons .swatch__button')
  swatches.forEach((swatch) => {
    swatch.addEventListener('mouseenter', (event) => {
      const swatchLabel = event.currentTarget.dataset.swatchLabel;
      const swatchLabelContainer = document.querySelectorAll('.product__content .swatch-label')
      swatchLabelContainer.forEach((container) => container.textContent = `(${swatchLabel})`);
    })
  })
  // PLP
  const collectionSwatches = document.querySelectorAll('.product-item__swatches__holder .swatch__button');
  collectionSwatches.forEach((swatch) => {
     swatch.addEventListener('mouseenter', (event) => { 
      const swatchLabel = event.currentTarget.dataset.swatchLabel;
      console.log(swatchLabel)
      const swatchLabelContainer = swatch.parentElement.querySelector('.swatch-label');
      swatchLabelContainer.textContent = `(${swatchLabel})`;
    })
  });
});
